import DetailAnnounce from "./DetailAnnounce";

export default function AnnouncementContainer() {
  return (
    <div className="w-full p-6 bg-white rounded-lg">
      <DetailAnnounce />
    </div>
  );
}
